import { ReactComponent as CursorCrosshair } from 'approot/shared/icons/icon_cursor_crosshair.svg';
import Icon, { IconProps } from './icon';

const IconCursorCrosshair = (props: IconProps & { id?: string }) => {
  return <Icon {...props} Svg={CursorCrosshair} />;
};

export default IconCursorCrosshair;
